import { FC, useEffect, useState } from 'react'
import { useUser, useAuthUI } from '@corratech/pylot-auth-manager'
import { useUI } from '@corratech/pylot-ui/context'
import { useRouter } from 'next/router'

type PropTypes = {
    authRequired: boolean
}

const AuthWrapper: FC<PropTypes> = ({ authRequired, children }) => {
    const { isSignedIn, loading } = useUser()
    const { LoadingIndicator } = useUI()
    const router = useRouter()
    const { openAuthModal } = useAuthUI()
    const [mounted, setMounted] = useState(false)

    useEffect(() => {
        setMounted(true)
    }, [])

    useEffect(() => {
        if (!loading && !isSignedIn && authRequired) {
            //open modal for guest user after redirection to home
            router.push('/').then(() => {
                openAuthModal()
            })
        }
    }, [loading, isSignedIn])

    // Solo para rutas protegidas: primer render del cliente = servidor, ambos sin
    // estado de auth (evita mismatch de hidratación en `loading`/`isSignedIn`).
    // Las rutas no protegidas no dependen de ese estado, así que no hay mismatch
    // que evitar, y suprimir su render dejaría la home (y otras rutas públicas)
    // sin contenido en el SSR.
    if (!mounted && authRequired) return null

    //consider loading state for only protected routes
    if (loading && authRequired) {
        return (
            <div className="mx-auto max-w-xs">
                <LoadingIndicator />
            </div>
        )
    }

    //Authentication error handler
    if (!isSignedIn && authRequired) return null

    return <>{children}</>
}

export default AuthWrapper
